import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-media-manager',
  templateUrl: './new-media-manager.component.html',
  styleUrls: ['./new-media-manager.component.css']
})
export class NewMediaManagerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
